export default __webpack_public_path__ + "static/western-power-splash-c3921af1268c1ae85d71f9b300ec5008.jpg";